import {
    GET_USER_NOTIFICATION_CONFIG_SUCCESS,
    GET_USER_NOTIFICATION_CONFIG_FAILURE,
    UPDATE_USER_NOTIFICATION_CONFIG_SUCCESS,
    UPDATE_USER_NOTIFICATION_CONFIG_FAILURE,
} from "./actions";

const initialState = {
    notificationConfig: [],
    getUserNotificationConfigResult: {
        success: true,
        error: null,
    },
    updateNotificationConfigResult: {
        success: true,
        error: null,
    },
};

export default (state = initialState, action) => {
    let notificationConfig = [];
    switch (action.type) {
        case GET_USER_NOTIFICATION_CONFIG_SUCCESS:
            notificationConfig = action.payload;
            return {
                ...state,
                getUserNotificationConfigResult: { success: true, error: null },
                notificationConfig,
            };
        case GET_USER_NOTIFICATION_CONFIG_FAILURE:
            return {
                ...state,
                getUserNotificationConfigResult: { success: false, error: action.payload },
                notificationConfig: [],
            };
        case UPDATE_USER_NOTIFICATION_CONFIG_SUCCESS:
            return {
                ...state,
                updateNotificationConfigResult: { success: true, error: null },
            };
        case UPDATE_USER_NOTIFICATION_CONFIG_FAILURE:
            return {
                ...state,
                updateNotificationConfigResult: { success: false, error: action.payload },
            };
        default:
            return state;
    }
};